"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_alexa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "83c3bc67-30eb-4068-a399-6258461836ef",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "alexa-hi"), /*#__PURE__*/React.createElement("g", {
    id: "441a818b-70ec-4263-8dba-1028f83ccf2f",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122,176H70a14,14,0,0,1-14-14V30A14,14,0,0,1,70,16h52a14,14,0,0,1,14,14V162A14,14,0,0,1,122,176Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 112,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120,114a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,120,114Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 112,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 112,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104,114a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,104,114Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,114a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,88,114Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 112,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72,114a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,72,114Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,174H70a14,14,0,0,1-14-14v2a14,14,0,0,0,14,14h52a14,14,0,0,0,14-14v-2A14,14,0,0,1,122,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 40.08,
    width: 80,
    height: 2.42
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 35.92,
    width: 80,
    height: 4.16,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 136,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120,138a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,120,138Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 136,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 136,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104,138a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,104,138Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,138a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,88,138Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 136,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72,138a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,72,138Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 124,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80,126a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,80,126Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 124,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96,126a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,96,126Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 124,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112,126a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,112,126Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "80789b3c-cd10-4a14-9027-8f6b61170cc4",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  })));
}

var _default = ic_alexa;
exports.default = _default;